import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import LogicaAPI from "./logicaapi";

/**
 * Uid2トークンのAPIクラス
 *
 * @extends {LogicaAPI}
 * @constructor
 */
class Uid2 extends LogicaAPI {
  /**
   * @typedef {Object} Uid2
   * @property {string} advertising_token - ユーザーの暗号化されたAdvertisingToken
   * @property {string} refresh_token - リフレッシュトークン
   * @property {number} identity_expires - AdvertisingTokenの有効期限のタイムスタンプ
   * @property {number} refresh_from - AdvertisingTokenの更新を開始するタイミングを示すタイムスタンプ
   * @property {number} refresh_expires - リフレッシュトークンの有効期限を示すタイムスタンプ
   * @property {string} refresh_response_key - リフレッシュトークンのレスポンスを復号するためのキー
   * @property {string} user_token - 使用しない
   */

  /**
   * @typedef {Object} Uid2Result
   * @property {string} email_hash
   * @property {Uid2} uid2
   */
  /**
   * generate.
   *
   * UID2トークンの生成
   *
   * @return {Primise<Uid2Result>} result
   */
  async generate() {
    return this.post("/api/v1/uid2/v2_generate");
  }

  /**
   * refresh.
   *
   * UID2トークンのリフレッシュ
   *
   * @param {string} token - リフレッシュトークン
   * @param {string} key - refresh_response_key
   * @param {string} hash - email_hash
   * @return {Promise<Uid2Result>} result
   */
  async refresh(token, key, hash) {
    const params = {
      refresh_token: token,
      refresh_response_key: key,
      email_hash: hash
    };
    return this.post("/api/v1/uid2/v2_refresh", {
      body: params
    });
  }
}
/**
 * @type {string} STATUS_SUCCESS
 */
_defineProperty(Uid2, "STATUS_SUCCESS", "success");
export default Uid2;